module.exports = __webpack_public_path__ + "static/media/anfrage-abschluss.ffdb19db.png";